import { Button, Cell, Image, Spacer, Text } from '@vinted/web-ui';
import classNames from 'classnames';
import useBreakpoint from 'hooks/useBreakpoint';
import useClosetCountdown from 'hooks/useClosetCountdown';
import useTranslate from 'hooks/useTranslate';
import useIsDarkMode from 'hooks/useIsDarkMode';
import FollowButton from 'components/FollowButton';
import SeparatedList from 'components/SeparatedList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ICON_NAME_64 = 'clothes-star-64.png';
const ICON_NAME_96 = 'clothes-star-96.png';

const ProfileCountdownBanner = _ref => {
  let {
    endDate,
    bottomElement,
    username,
    isFollowed,
    userId,
    viewingSelf,
    showActions
  } = _ref;
  const {
    formattedRemainingTime,
    isActive
  } = useClosetCountdown(endDate);
  const translate = useTranslate('closet_countdown');
  const breakpoints = useBreakpoint();
  const isDarkMode = useIsDarkMode();
  const hideFollowAction = !userId || isFollowed === undefined || viewingSelf || !showActions;
  const contentClasses = classNames('closet-countdown__content', {
    'closet-countdown__content--hidden-action': hideFollowAction
  });
  const iconName = breakpoints.tabletsUp ? ICON_NAME_96 : ICON_NAME_64;
  const iconPath = "/assets/closet-countdown".concat(isDarkMode ? '/dark' : '', "/").concat(iconName);
  if (!isActive) return null;

  const renderCountdown = () => {
    if (!formattedRemainingTime) return null;
    const {
      days,
      hours,
      minutes,
      seconds
    } = formattedRemainingTime;
    return /*#__PURE__*/_jsx("ul", {
      className: "closet-countdown__timer",
      children: /*#__PURE__*/_jsxs(SeparatedList, {
        separator: /*#__PURE__*/_jsx(Spacer, {
          orientation: Spacer.Orientation.Vertical
        }),
        children: [/*#__PURE__*/_jsxs("li", {
          className: "closet-countdown__timer-unit",
          children: [/*#__PURE__*/_jsx("div", {
            className: "closet-countdown__timer-unit-value",
            children: days
          }), /*#__PURE__*/_jsx("div", {
            className: "closet-countdown__timer-unit-name",
            children: translate('time.days', undefined, {
              count: days
            })
          })]
        }), /*#__PURE__*/_jsxs("li", {
          className: "closet-countdown__timer-unit",
          children: [/*#__PURE__*/_jsx("div", {
            className: "closet-countdown__timer-unit-value",
            children: hours
          }), /*#__PURE__*/_jsx("div", {
            className: "closet-countdown__timer-unit-name",
            children: translate('time.hours', undefined, {
              count: hours
            })
          })]
        }), /*#__PURE__*/_jsxs("li", {
          className: "closet-countdown__timer-unit",
          children: [/*#__PURE__*/_jsx("div", {
            className: "closet-countdown__timer-unit-value",
            children: minutes
          }), /*#__PURE__*/_jsx("div", {
            className: "closet-countdown__timer-unit-name",
            children: translate('time.minutes', undefined, {
              count: minutes
            })
          })]
        }), /*#__PURE__*/_jsxs("li", {
          className: "closet-countdown__timer-unit",
          children: [/*#__PURE__*/_jsx("div", {
            className: "closet-countdown__timer-unit-value",
            children: seconds
          }), /*#__PURE__*/_jsx("div", {
            className: "closet-countdown__timer-unit-name",
            children: translate('time.seconds', undefined, {
              count: seconds
            })
          })]
        })]
      })
    });
  };

  const renderTitle = () => {
    if (!userId || isFollowed === undefined || viewingSelf || !showActions) return null;

    if (breakpoints.tabletsUp) {
      return /*#__PURE__*/_jsx("h2", {
        className: "closet-countdown__title",
        children: translate('title', {
          username
        })
      });
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.XLarge
      }), /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Title,
        children: translate('title', {
          username
        })
      })]
    });
  };

  const renderFollowButton = () => {
    if (!userId || isFollowed === undefined || viewingSelf || !showActions) return null;
    return /*#__PURE__*/_jsx(FollowButton, {
      userId: userId,
      username: username,
      isActive: isFollowed,
      size: Button.Size.Medium
    });
  };

  if (breakpoints.tabletsUp) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("section", {
        className: "u-flexbox u-align-items-center u-justify-content-between u-padding-horizontal-medium",
        children: [/*#__PURE__*/_jsxs("div", {
          className: contentClasses,
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Image, {
              src: iconPath,
              size: Image.Size.X2Large,
              alt: ""
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "u-flexbox u-flex-direction-column",
            children: [/*#__PURE__*/_jsx(Text, {
              theme: "amplified",
              children: translate('subtitle')
            }), /*#__PURE__*/_jsx(Spacer, {}), renderCountdown()]
          }), renderTitle()]
        }), /*#__PURE__*/_jsx("div", {
          className: "closet-countdown__button",
          children: renderFollowButton()
        })]
      }), bottomElement]
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: "closet-countdown",
    children: /*#__PURE__*/_jsxs(Cell, {
      styling: Cell.Styling.Tight,
      children: [/*#__PURE__*/_jsx("div", {
        className: "closet-countdown__image",
        children: /*#__PURE__*/_jsx(Image, {
          src: iconPath,
          size: Image.Size.XLarge,
          alt: ""
        })
      }), /*#__PURE__*/_jsx(Text, {
        theme: "amplified",
        children: translate('subtitle')
      }), /*#__PURE__*/_jsx(Spacer, {}), renderCountdown(), renderTitle(), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.XLarge
      }), renderFollowButton(), bottomElement]
    })
  });
};

export default ProfileCountdownBanner;